import { MARKETING_OBJECTIVE_KEYS } from 'modules/campaigns/modules/common-campaign-form';

export const CONVERSION_CATEGORY = {
    VIEW_CONTENT: 'VIEW_CONTENT',
    SEARCH: 'SEARCH',
    ADD_TO_CART: 'ADD_TO_CART',
    ADD_TO_WISHLIST: 'ADD_TO_WISHLIST',
    START_CHECKOUT: 'START_CHECKOUT',
    ADD_PAYMENT_INFO: 'ADD_PAYMENT_INFO',
    MAKE_PURCHASE: 'MAKE_PURCHASE',
    LEAD: 'LEAD',
    COMPLETE_REGISTRATION: 'COMPLETE_REGISTRATION',
    APP_INSTALL: 'APP_INSTALL',
    OTHER: 'OTHER',
    SIGNUP: 'SIGNUP',
    CONTACT: 'CONTACT',
    SUBSCRIBE: 'SUBSCRIBE',
    ENGAGEMENT: 'ENGAGEMENT',
};

export const MARKETING_OBJECTIVES_CUSTOM_CONVERSION_CONFIG = {
    [MARKETING_OBJECTIVE_KEYS.ONLINE_PURCHASES]: {
        conversionName: '',
        showIncludeInTotalToggleValue: false,
        includeInTotalConversions: false,
    },
    [MARKETING_OBJECTIVE_KEYS.LEADS_GENERATION]: {
        conversionName: '',
        showIncludeInTotalToggleValue: false,
        includeInTotalConversions: false,
    },
    [MARKETING_OBJECTIVE_KEYS.MOBILE_APP_INSTALL]: {
        conversionName: '',
        showIncludeInTotalToggleValue: false,
        includeInTotalConversions: false,
    },
    [MARKETING_OBJECTIVE_KEYS.BRAND_AWARENESS]: {
        conversionName: '',
        showIncludeInTotalToggleValue: true,
        includeInTotalConversions: true,
    },
    [MARKETING_OBJECTIVE_KEYS.DRIVE_WEBSITE_TRAFFIC]: {
        conversionName: '',
        showIncludeInTotalToggleValue: true,
        includeInTotalConversions: true,
    },
};

export const MARKETING_OBJECTIVES_CONFIG = {
    [MARKETING_OBJECTIVE_KEYS.ONLINE_PURCHASES]: [
        {
            conversionName: 'Make Purchase',
            includeInTotalToggleInUI: false,
            includeInTotalConversions: true,
            category: CONVERSION_CATEGORY.MAKE_PURCHASE,
        },
        {
            conversionName: 'Add Payment Info',
            includeInTotalToggleInUI: false,
            includeInTotalConversions: true,
            category: CONVERSION_CATEGORY.ADD_PAYMENT_INFO,
        },
        {
            conversionName: 'Start Checkout',
            includeInTotalToggleInUI: false,
            includeInTotalConversions: true,
            category: CONVERSION_CATEGORY.START_CHECKOUT,
        },
        {
            conversionName: 'Add To Cart',
            includeInTotalToggleInUI: false,
            includeInTotalConversions: true,
            category: CONVERSION_CATEGORY.ADD_TO_CART,
        },
        {
            conversionName: 'Add to Wishlist',
            includeInTotalToggleInUI: false,
            includeInTotalConversions: false,
            category: CONVERSION_CATEGORY.ADD_TO_WISHLIST,
        },
        {
            conversionName: 'View Content',
            includeInTotalToggleInUI: false,
            includeInTotalConversions: false,
            category: CONVERSION_CATEGORY.VIEW_CONTENT,
        },
    ],
    [MARKETING_OBJECTIVE_KEYS.LEADS_GENERATION]: [
        {
            conversionName: 'Qualified Lead',
            includeInTotalToggleInUI: false,
            includeInTotalConversions: true,
            category: CONVERSION_CATEGORY.LEAD,
        },
        {
            conversionName: 'Lead Submit',
            includeInTotalToggleInUI: false,
            includeInTotalConversions: true,
            category: CONVERSION_CATEGORY.LEAD,
        },
        // {
        //     conversionName: 'Multistep Lead',
        //     includeInTotalToggleInUI: false,
        //     includeInTotalConversions: false,
        //     category: CONVERSION_CATEGORY.LEAD,
        // },
        //Will Be Added in the future
        {
            conversionName: 'View Content',
            includeInTotalToggleInUI: false,
            includeInTotalConversions: false,
            category: CONVERSION_CATEGORY.VIEW_CONTENT,
        },
    ],
    [MARKETING_OBJECTIVE_KEYS.MOBILE_APP_INSTALL]: [
        {
            conversionName: 'Make Purchase',
            includeInTotalToggleInUI: false,
            includeInTotalConversions: true,
            category: CONVERSION_CATEGORY.MAKE_PURCHASE,
        },
        {
            conversionName: 'Complete Registration',
            includeInTotalToggleInUI: false,
            includeInTotalConversions: true,
            category: CONVERSION_CATEGORY.COMPLETE_REGISTRATION,
        },
        {
            conversionName: 'App Install',
            includeInTotalToggleInUI: false,
            includeInTotalConversions: true,
            category: CONVERSION_CATEGORY.APP_INSTALL,
        },
        {
            conversionName: 'View Content',
            includeInTotalToggleInUI: false,
            includeInTotalConversions: false,
            category: CONVERSION_CATEGORY.VIEW_CONTENT,
        },
    ],
    [MARKETING_OBJECTIVE_KEYS.BRAND_AWARENESS]: [
        {
            conversionName: 'View Content',
            includeInTotalToggleInUI: true,
            includeInTotalConversions: true,
            category: CONVERSION_CATEGORY.VIEW_CONTENT,
        },
    ],
    [MARKETING_OBJECTIVE_KEYS.DRIVE_WEBSITE_TRAFFIC]: [
        {
            conversionName: 'View Content',
            includeInTotalToggleInUI: true,
            includeInTotalConversions: true,
            category: CONVERSION_CATEGORY.VIEW_CONTENT,
        },
    ],
};
